export var createMuiFormGroupOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            "[class*='MuiFormLabel-root'] + &": {
                marginTop: spacing(2),
            },
        },
    });
};
//# sourceMappingURL=MuiFormGroup.js.map